/**
 * src/pages/landing/AuthFormCard.tsx
 *
 * Mount point for the sign-in screen. Phase 42: this file used to hold the entire
 * magic-link form (state machine, form JSX) — that markup moved to
 * src/features/auth/ui/{MagicLinkForm,GoogleSignInButton,LoginCard}.tsx. This file stays
 * in src/pages/landing/ — LandingPage.tsx's contract (a prop-less component) is
 * unchanged — and is now a thin shell that mounts LoginCard.
 *
 * Side effect worth noting: the deep import of useAuth (`@/features/auth/hooks/useAuth`)
 * that used to live here disappeared along with the old body — no separate fix needed.
 */

import { FC } from 'react';
import { LoginCard } from '@/features/auth';

export const AuthFormCard: FC = () => <LoginCard />;
